import React from "react";
import { useStore } from "store";
import { cn } from "helpers/style";
import styles from "./Copyright.module.scss";

type Props = {
  showOnDesktop?: boolean;
};

const Copyright: React.FC<Props> = ({ showOnDesktop }: Props) => {
  const { settings } = useStore();

  return (
    <div
      className={cn([
        styles.footer500Copyright,
        showOnDesktop && styles.footer500CopyrightShowOnDesktop,
      ])}
    >
      <p
        className={cn([
          styles.footer500CopyrightText,
          styles.footer500CopyrightTextPrimary,
        ])}
      >
        © {settings.year} ООО «ПроАптека», <br /> ИНН 9715268877, ОГРН
        1167746723517
      </p>
      <p
        className={cn([
          styles.footer500CopyrightText,
          styles.footer500CopyrightTextSecondary,
        ])}
      >
        Адрес места нахождения: 127282,{" "}
        <nobr>г. Москва, ул. Чермянская, д. 2, стр. 1</nobr>
      </p>
      <p
        className={cn([
          styles.footer500CopyrightText,
          styles.footer500CopyrightTextSecondary,
        ])}
      >
        Информация на сайте носит ознакомительный характер и не может служить
        заменой очной консультации врача.
      </p>
    </div>
  );
};

export default Copyright;
